// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Checkbox from "./Checkbox.js";
import * as Buhta_cabinet__EventHandlers from "../../util/EventHandlers.js";
import * as Buhta_components__Icons from "../../../../../packages/components/src/Icons.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CheckSvg from "static/icons/check.svg";
import SelectArrowsSvg from "static/icons/select-arrows.svg";

const _map = {"Bottom":"Bottom","BottomRight":"BottomRight","BottomLeft":"BottomLeft","BottomCenter":"BottomCenter","LeftTop":"LeftTop","LeftBottom":"LeftBottom","LeftCenter":"LeftCenter","TopRight":"TopRight","TopLeft":"TopLeft","TopCenter":"TopCenter","RightTop":"RightTop","RightBottom":"RightBottom","RightCenter":"RightCenter"};

function alignTypeToJs(param) {
  return param;
}

function alignTypeFromJs(param) {
  return _map[param];
}

function contentWrapper(align) {
  const alignRules = align === "BottomCenter" ? "top-full left-1/2 -translate-x-1/2" : (
      align === "RightCenter" ? "left-full top-1/2 -translate-y-1/2" : (
          align === "TopCenter" ? "bottom-full left-1/2 -translate-x-1/2" : (
              align === "LeftBottom" ? "right-full top-0" : (
                  align === "TopRight" ? "bottom-full left-0" : (
                      align === "Bottom" ? "top-full left-0" : (
                          align === "BottomLeft" ? "top-full right-0" : (
                              align === "LeftCenter" ? "right-full top-1/2 -translate-y-1/2" : (
                                  align === "BottomRight" ? "top-full left-0" : (
                                      align === "RightBottom" ? "right-full top-0" : (
                                          align === "TopLeft" ? "bottom-full right-0" : (
                                              align === "RightTop" ? "left-full bottom-0" : "right-full bottom-0"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  return Cn.fromList({
              hd: "absolute min-w-full z-20",
              tl: {
                hd: alignRules,
                tl: /* [] */0
              }
            });
}

function content(isDropdownShown, background) {
  return Cn.fromList({
              hd: "animate-fadeScaleIn rounded border border-gray-main shadow-dropdown",
              tl: {
                hd: isDropdownShown ? "block" : "hidden",
                tl: {
                  hd: background,
                  tl: /* [] */0
                }
              }
            });
}

const Custom = {
  contentWrapper: contentWrapper,
  content: content
};

const item = "px-4 py-1.5 whitespace-nowrap flex items-center cursor-pointer hover:bg-asphalt";

const itemIcon = "mr-3";

const itemSubitem = "ml-auto pl-3";

const List = {
  item: item,
  itemIcon: itemIcon,
  itemSubitem: itemSubitem
};

const selectActivator = "flex items-center pl-1.5 hover:bg-gray-light";

const select = "flex flex-col bg-black py-2 rounded";

const item$1 = "py-1 px-6 whitespace-nowrap relative cursor-pointer hover:bg-secondary";

const itemIcon$1 = "absolute left-2 top-5px";

const Select = {
  selectActivator: selectActivator,
  select: select,
  item: item$1,
  itemIcon: itemIcon$1
};

const Styles = {
  Custom: Custom,
  List: List,
  Select: Select
};

function make(className) {
  return function (innerClassName) {
    return function (alignOpt) {
      const align = alignOpt !== undefined ? alignOpt : "BottomRight";
      return function (activator) {
        return function (backgroundOpt) {
          const background = backgroundOpt !== undefined ? backgroundOpt : "bg-black";
          return function (isDropdownShown) {
            return function (setIsDropdownShown) {
              return function (children) {
                return function (activatorBgOpt) {
                  const activatorBg = activatorBgOpt !== undefined ? activatorBgOpt : false;
                  const activatorRef = React.useRef(null);
                  const dropdownRef = React.useRef(null);
                  Buhta_cabinet__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
                          Curry._1(setIsDropdownShown, (function (param) {
                                  return false;
                                }));
                        }));
                  const onClickedInside = function (ev) {
                    ev.stopPropagation();
                  };
                  return JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      ref: activatorRef,
                                      children: Curry._1(activator, undefined),
                                      className: Cn.fromList({
                                            hd: "cursor-pointer",
                                            tl: {
                                              hd: Cn.on("bg-gray-pale rounded-sm", isDropdownShown && activatorBg),
                                              tl: /* [] */0
                                            }
                                          }),
                                      onClick: (function (param) {
                                          Curry._1(setIsDropdownShown, (function (param) {
                                                  return !isDropdownShown;
                                                }));
                                        })
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            ref: dropdownRef,
                                            children: children,
                                            className: content(isDropdownShown, background)
                                          }),
                                      className: Cn.fromList({
                                            hd: contentWrapper(align),
                                            tl: {
                                              hd: Cn.take(innerClassName),
                                              tl: /* [] */0
                                            }
                                          })
                                    })
                              ],
                              className: Cn.fromList({
                                    hd: "relative pt-1",
                                    tl: {
                                      hd: Cn.take(className),
                                      tl: {
                                        hd: Cn.on("!pt-0", isDropdownShown && activatorBg),
                                        tl: /* [] */0
                                      }
                                    }
                                  }),
                              onClick: onClickedInside
                            });
                };
              };
            };
          };
        };
      };
    };
  };
}

function Dropdown$Custom(Props) {
  return Curry._7(make(Props.className)(Props.innerClassName), Props.align, Props.activator, Props.background, Props.isDropdownShown, Props.setIsDropdownShown, Props.children, Props.activatorBg);
}

const Custom$1 = {
  make: Dropdown$Custom
};

function make$1(className) {
  return function (activator) {
    return function (isDropdownShown) {
      return function (setIsDropdownShown) {
        return function (title) {
          return function ($staropt$star) {
            if ($staropt$star === undefined) {
              true;
            }
            return function (background) {
              return function (align) {
                return function (listOpt) {
                  const list = listOpt !== undefined ? listOpt : /* [] */0;
                  let tmp = {
                    activator: activator,
                    isDropdownShown: isDropdownShown,
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            title !== undefined ? JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                          className: "text-gray-medium",
                                          children: title
                                        }),
                                    className: "py-3 px-4"
                                  }) : null,
                            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(list, (function (index, item$2) {
                                        const Key = "dropdown-list--item#" + String(index);
                                        return JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                    isChecked: item$2.state,
                                                    whiteMode: true,
                                                    onChange: (function (param) {
                                                        Curry._1(item$2.onChange, undefined);
                                                      }),
                                                    text: item$2.value,
                                                    className: item
                                                  }, Key);
                                      })))
                          ],
                          className: "flex flex-col"
                        })
                  };
                  if (className !== undefined) {
                    tmp.className = Caml_option.valFromOption(className);
                  }
                  if (align !== undefined) {
                    tmp.align = Caml_option.valFromOption(align);
                  }
                  if (background !== undefined) {
                    tmp.background = Caml_option.valFromOption(background);
                  }
                  return JsxRuntime.jsx(Dropdown$Custom, tmp);
                };
              };
            };
          };
        };
      };
    };
  };
}

function Dropdown$CheckboxGroup(Props) {
  return Curry._7(make$1(Props.className)(Props.activator), Props.isDropdownShown, Props.setIsDropdownShown, Props.title, Props.hasCloseButton, Props.background, Props.align, Props.list);
}

const CheckboxGroup = {
  make: Dropdown$CheckboxGroup
};

function make$2(className) {
  return function (isDropdownShown) {
    return function (setIsDropdownShown) {
      return function ($staropt$star) {
        if ($staropt$star === undefined) {
          true;
        }
        return function (align) {
          return function (optionsOpt) {
            const options = optionsOpt !== undefined ? optionsOpt : /* [] */0;
            return function (labelOpt) {
              const label = labelOpt !== undefined ? labelOpt : "Выберите";
              return function (selectedValue) {
                return function (onChange) {
                  const activator = function (param) {
                    let tmp;
                    if (selectedValue !== undefined) {
                      const option = Belt__Belt_List.getBy(options, (function (option) {
                              return option.value === selectedValue;
                            }));
                      tmp = option !== undefined ? option.text : null;
                    } else {
                      tmp = label;
                    }
                    return JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                        children: tmp
                                      }),
                                  JsxRuntime.jsx(SelectArrowsSvg, {})
                                ],
                                className: selectActivator
                              });
                  };
                  let tmp = {
                    activator: activator,
                    isDropdownShown: isDropdownShown,
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsx("div", {
                          children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(options, (function (index, option) {
                                      const Key = "dropdown-select--item#" + String(index);
                                      return JsxRuntime.jsxs("div", {
                                                  children: [
                                                    selectedValue !== undefined && option.value === selectedValue ? JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(CheckSvg, {}),
                                                            className: itemIcon$1
                                                          }) : null,
                                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          className: "text-white",
                                                          children: option.text
                                                        })
                                                  ],
                                                  className: item$1,
                                                  onClick: (function (param) {
                                                      Curry._1(onChange, option.value);
                                                    })
                                                }, Key);
                                    }))),
                          className: select
                        })
                  };
                  if (className !== undefined) {
                    tmp.className = Caml_option.valFromOption(className);
                  }
                  if (align !== undefined) {
                    tmp.align = Caml_option.valFromOption(align);
                  }
                  return JsxRuntime.jsx(Dropdown$Custom, tmp);
                };
              };
            };
          };
        };
      };
    };
  };
}

function Dropdown$Selectbox(Props) {
  return Curry._7(make$2(Props.className)(Props.isDropdownShown), Props.setIsDropdownShown, Props.hasCloseButton, Props.align, Props.options, Props.label, Props.selectedValue, Props.onChange);
}

const Selectbox = {
  make: Dropdown$Selectbox
};

function make$3(className) {
  return function (activator) {
    return function (isDropdownShown) {
      return function (setIsDropdownShown) {
        return function (title) {
          return function ($staropt$star) {
            if ($staropt$star === undefined) {
              true;
            }
            return function (background) {
              return function (align) {
                return function (action) {
                  return function (listOpt) {
                    const list = listOpt !== undefined ? listOpt : /* [] */0;
                    let tmp;
                    if (action !== undefined) {
                      const match = action.icon;
                      const subvalue = action.subvalue;
                      tmp = JsxRuntime.jsxs("div", {
                            children: [
                              match !== undefined ? JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_components__Icons.IconAddInCircle.make, {
                                            alt: "logo"
                                          }),
                                      className: itemIcon
                                    }) : null,
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-white",
                                    children: action.value
                                  }),
                              subvalue !== undefined ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: Cn.fromList({
                                            hd: itemSubitem,
                                            tl: {
                                              hd: "text-default-gray",
                                              tl: /* [] */0
                                            }
                                          }),
                                      children: subvalue
                                    }) : null
                            ],
                            className: Cn.fromList({
                                  hd: item,
                                  tl: {
                                    hd: "py-3.5 border-t border-white/12",
                                    tl: /* [] */0
                                  }
                                }),
                            onClick: (function (param) {
                                Curry._1(action.onClick, undefined);
                              })
                          });
                    } else {
                      tmp = null;
                    }
                    let tmp$1 = {
                      activator: activator,
                      isDropdownShown: isDropdownShown,
                      setIsDropdownShown: setIsDropdownShown,
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              title !== undefined ? JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                            className: "text-gray-medium",
                                            children: title
                                          }),
                                      className: "py-3 px-4"
                                    }) : null,
                              Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(list, (function (index, item$2) {
                                          const Key = "dropdown-list--item#" + String(index);
                                          const icon = item$2.icon;
                                          const subvalue = item$2.subvalue;
                                          return JsxRuntime.jsxs("div", {
                                                      children: [
                                                        icon !== undefined ? JsxRuntime.jsx("div", {
                                                                children: Caml_option.valFromOption(icon),
                                                                className: itemIcon
                                                              }) : null,
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "text-white",
                                                              children: item$2.value
                                                            }),
                                                        subvalue !== undefined ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                className: Cn.fromList({
                                                                      hd: itemSubitem,
                                                                      tl: {
                                                                        hd: "text-default-gray",
                                                                        tl: /* [] */0
                                                                      }
                                                                    }),
                                                                children: subvalue
                                                              }) : null
                                                      ],
                                                      className: item,
                                                      onClick: (function (param) {
                                                          Curry._1(item$2.onClick, undefined);
                                                        })
                                                    }, Key);
                                        }))),
                              tmp
                            ],
                            className: "flex flex-col"
                          })
                    };
                    if (className !== undefined) {
                      tmp$1.className = Caml_option.valFromOption(className);
                    }
                    if (align !== undefined) {
                      tmp$1.align = Caml_option.valFromOption(align);
                    }
                    if (background !== undefined) {
                      tmp$1.background = Caml_option.valFromOption(background);
                    }
                    return JsxRuntime.jsx(Dropdown$Custom, tmp$1);
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function Dropdown$List(Props) {
  return Curry._8(make$3(Props.className)(Props.activator), Props.isDropdownShown, Props.setIsDropdownShown, Props.title, Props.hasCloseButton, Props.background, Props.align, Props.action, Props.list);
}

const List$1 = {
  make: Dropdown$List
};

export {
  alignTypeToJs ,
  alignTypeFromJs ,
  Styles ,
  Custom$1 as Custom,
  CheckboxGroup ,
  Selectbox ,
  List$1 as List,
}
/* Buhta_cabinet__Checkbox Not a pure module */
